const mockData = {
  hero: {
    badge: 'Trusted Since 2020',
    title: 'Professional Rust Repair & Truck Undercoating',
    subtitle: 'Protect your vehicle from rust and corrosion with our expert services. Quality workmanship guaranteed.',
    backgroundImage: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/jj7wd6ag_LASER_REMOVAL.gif'
  },
  features: [
    {
      icon: 'Shield',
      title: 'Lifetime Protection',
      description: 'Our premium undercoating provides long-lasting protection against rust and corrosion.'
    },
    {
      icon: 'Award',
      title: 'Expert Technicians',
      description: 'Certified professionals with years of experience in automotive rust treatment.'
    },
    {
      icon: 'Clock',
      title: 'Fast Turnaround',
      description: 'Most services completed within 24-48 hours. We respect your time.'
    },
    {
      icon: 'Wrench',
      title: 'Quality Materials',
      description: 'We use only premium, industry-leading products for maximum durability.'
    }
  ],
  services: [
    {
      title: 'Automotive Rust Repair',
      description: 'Complete rust removal and repair services to restore your vehicle\'s structural integrity and appearance.',
      image: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/cj7mqghy_Screenshot_20260104_174355_Chrome.jpg',
      features: [
        'Surface rust treatment',
        'Structural rust repair',
        'Panel replacement when needed',
        'Professional refinishing',
        'Rust prevention coating'
      ]
    },
    {
      title: 'Truck Undercoating',
      description: 'Professional undercoating application to protect your truck\'s undercarriage from road salt, moisture, and debris.',
      image: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/hmtw86fd_Screenshot_20260104_174647_Chrome.jpg',
      features: [
        'Complete undercarriage cleaning',
        'Premium undercoating application',
        'Cavity wax injection',
        'Wheel well protection',
        'Annual inspection included'
      ]
    },
    {
      title: 'Laser Rust Cleaning',
      description: 'Revolutionary rust removal technology that preserves the base metal without chemicals.',
      image: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/2w5qp6au_what-is-laser-rust-removal-and-how-does-it-work_img_01_2109651.webp',
      features: [
        'Chemical-free rust removal',
        'Preserves base metal',
        'No surface damage',
        'Environmentally friendly',
        'Prepares surface for coating'
      ]
    }
  ],
  laserServices: {
    title: 'Advanced Laser Technology',
    subtitle: 'State-of-the-art laser welding and rust removal services',
    services: [
      {
        title: 'Laser Welding',
        description: 'Precision laser welding for automotive applications with minimal heat distortion.',
        icon: 'Wrench',
        features: [
          'High-precision welding',
          'Minimal heat-affected zone',
          'Aluminum and steel welding',
          'Thin material welding',
          'No filler material needed',
          'Perfect for classic car restoration'
        ]
      },
      {
        title: 'Laser Rust Cleaning',
        description: 'Revolutionary rust removal technology that preserves the base metal without chemicals.',
        icon: 'Shield',
        features: [
          'Chemical-free rust removal',
          'Preserves base metal',
          'No surface damage',
          'Environmentally friendly',
          'Fast and efficient',
          'Prepares surface for coating'
        ]
      }
    ]
  },
  restorationServices: [
    {
      title: 'Classic Car Restoration',
      description: 'Complete restoration services for American muscle cars and vintage classics.',
      icon: 'Award',
      features: [
        'Frame-off restoration',
        'Engine rebuilding and tuning',
        'Interior restoration and upholstery',
        'Original paint color matching',
        'Chrome and trim restoration'
      ]
    },
    {
      title: 'Metal Fabrication',
      description: 'Expert custom metal work and fabrication for all restoration projects.',
      icon: 'Wrench',
      features: [
        'Custom panel fabrication',
        'Patch panel installation',
        'Fender and quarter panel repair',
        'Floor pan replacement',
        'Structural welding'
      ]
    },
    {
      title: 'European Classic Restoration',
      description: 'Specialized restoration for European sports cars and luxury vehicles.',
      icon: 'Shield',
      features: [
        'Mercedes, BMW, Porsche specialists',
        'Authentic parts sourcing',
        'European paint specifications',
        'Period-correct restoration',
        'Certification documentation'
      ]
    },
    {
      title: 'Frame & Chassis Repairs',
      description: 'Professional structural repair and frame restoration services.',
      icon: 'Clock',
      features: [
        'Frame straightening and alignment',
        'Rust removal and treatment',
        'Structural reinforcement',
        'Subframe replacement',
        'Suspension mounting repair'
      ]
    }
  ],
  beforeAfter: [
    {
      before: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/ch241ygx_1000000132.jpg',
      after: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/mwxwk4kg_1000000133.jpg',
      title: 'Rocker Panel Restoration',
      description: 'Complete rust removal and panel replacement'
    },
    {
      before: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/6ny0kefz_1000000130.jpg',
      after: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/d38n4aiv_1000000131.jpg',
      title: 'Undercoating',
      description: 'Professional rust treatment and refinishing'
    },
    {
      before: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/mzrvuf3u_1000000128.jpg',
      after: 'https://customer-assets.emergentagent.com/job_rust-remedy/artifacts/wsern0j9_1000000129.jpg',
      title: 'Body Panel Restoration',
      description: 'From severe rust damage to pristine condition'
    }
  ],
  gallery: [
    {
      url: 'https://images.unsplash.com/photo-1517524206127-48bbd363f3d7?w=400',
      alt: 'Engine Work'
    },
    {
      url: 'https://images.unsplash.com/photo-1551522435-a13afa10f103?w=400',
      alt: 'Professional Garage'
    },
    {
      url: 'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=400',
      alt: 'Maintenance Work'
    },
    {
      url: 'https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg?w=400',
      alt: 'Workshop Tools'
    },
    {
      url: 'https://images.unsplash.com/photo-1570129476815-ba368ac77013?w=400',
      alt: 'Tool Setup'
    },
    {
      url: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?w=400',
      alt: 'Mechanic at Work'
    },
    {
      url: 'https://images.unsplash.com/photo-1596986952526-3be237187071?w=400',
      alt: 'Auto Repair Shop'
    },
    {
      url: 'https://images.pexels.com/photos/2244746/pexels-photo-2244746.jpeg?w=400',
      alt: 'Undercarriage Work'
    }
  ],
  contact: {
    phone: '(570) 426-0713',
    email: 'contactautorustpro@gmail.com',
    address: '318 Pheasant Run, East Stroudsburg, PA 18302',
    hours: 'Mon-Fri: 8AM-6PM, Sat: 9AM-4PM'
  }
};

export default mockData;